import { useDispatch, useSelector } from "react-redux";
import { fetchAllRoles } from "../../bmr/slices/roles";
import { useEffect, useState } from "react";
import { deleteOnboardUser, disableAddModal, enableAddModal, fetchOnboardUser, selectBmrAddModal, selectBmrAllOnBoardUser } from "../../bmr/slices/onBoardUser";
import { Box, Button, Grid, IconButton, Tooltip } from "@mui/material";
import { EditIconButton, EyeIconButton } from "../../assets/common-svg/CommonSvg";
import BsModal from "../../bmr/components/common/BaseModal";
import Datatable from "../../bmr/components/features/Datatable";
// import { Filter } from "@mui/icons-material";
import DeleteModal from "../../bmr/components/common/BaseModal/DeleteModal";
import ListDrawer from "../../components/ListDrawer/ListDrawer";
import AssignNewPermission from "./assign-new-permission";
import { useNavigate } from "react-router";
import AssignedFormFilters from "./form-assigned-filter";
import { CustomSwitch } from "../../components/custom-switch/CustomSwitch";

const FormAssigned = () => {
    const dispatch = useDispatch()
    const navigate=useNavigate()
    // const allRoles = useSelector(selectAllRoles)
    const [openDrawer, setOpenDrawer] = useState(false)
    // const [phaseList, setPhaseList] = useState([])
    const [allFilters, setFilters] = useState(false);
    const allOnBoardUser = useSelector(selectBmrAllOnBoardUser)
    const addModal = useSelector(selectBmrAddModal)
    const [rowId, setRowId] = useState(null)
    const [open, setOpen] = useState(false)
   const [viewPermissions, setViewPermissions] = useState({});

    const updateFilter = (filter) => {
        setFilters(filter)
        fetchUsers(filter);
    }

    const filterConfig = {
        role_id: {
            label: "Role Type",
            enums:['a', 'b']
                        // enum: allRoles.reduce((acc, role) => {
            //     acc[role.id] = role.title;
            //     return acc;
            // }, {})
        },
    }

    const getAllRoles = async () => {
        await dispatch(fetchAllRoles())
    }

    useEffect(() => {
        getAllRoles()
    }, [])

    const fetchUsers = async (filter) => {
        await dispatch(disableAddModal())
        await dispatch(fetchOnboardUser(filter))
    }

    const handleCloseModal = async () => {
        await dispatch(disableAddModal())
    }
    const handleAddModal = async () => {
        await dispatch(enableAddModal())
    }

    const handleDelete = async () => {
        await dispatch(deleteOnboardUser({ editId: rowId, filters: allFilters }))
        setOpen(false)
    }

const handleViewToggle = (event, rowId) => {
  const checked = event.target.checked;

  setViewPermissions((prev) => ({
    ...prev,
    [rowId]: checked,
  }));
};



    const columns = [
        {
            id: 'trmplate_name',
            name: 'Template Name',
            selector: row => row.template_name,
            sortable: true,
        },
        {
            id: 'version',
            name: 'Version',
            selector: row => row.version,
            sortable: true
        },
        {
            id: 'form_type',
            name: 'Form Type',
            selector: row => row.form_type,
            sortable: true
        },
        {
            id: 'approval_level',
            name: 'Approval Level',
            selector: row => row.approval_level,
        sortable: true
        },
        {
            id: 'role_approval',
            name: 'Roles for Approval',
            selector: row => row.roles_approval,
            sortable: true,
            align: 'center'
        },
        {
            id: 'active_inactive',
            name: 'Active/ In-Active',
            selector: row => <Box key={row.id}>
                <CustomSwitch
                    toggle={viewPermissions[row.id] || false}
                    handleSwitch={(e) => handleViewToggle(e, row.id)}
                    disableChip={false}
                />
            </Box>,
            sortable: true,
            align: 'center'
        },
        {
            name: 'Action',
            align: 'center',
            selector: row => <Box key={row.id}>
                 <Tooltip title="View Permission" >
                    <span>
                        <IconButton onClick={() => navigate(`/bmr/assigned-permission/assign-section-permission`, {
                            state: [
                                { name: "Assign Template", path: '/bmr/assigned-permission' },
                                { name: "Assign Section Permission", path: '/bmr/assigned-permission/assign-section-permission' }]
                        }
                        )}>
                            <EyeIconButton
                                bgColor={"#3571FF"}
                            />
                        </IconButton>
                    </span>
                </Tooltip> 
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => { setRowId(row.id), handleAddModal() }}
                        >
                            <EditIconButton
                                bgColor={"#C3C3C3"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                {/* <Tooltip title="Delete" >
                    <span>
                        <IconButton
                            onClick={() => { setRowId(row.id), setOpen(true) }}
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                            />
                        </IconButton>
                    </span>
                </Tooltip> */}
            </Box>
        },
    ];

    return (
        <Grid container className='m-4 ml-0 mainDiv' rowSpacing={4.5} columnSpacing={2.75}>
            <BsModal open={addModal} size={'md'} onClose={handleCloseModal} title={rowId ? "Edit Assign Templates" : "Assign Template Permission"}>
                <AssignNewPermission editId={rowId} filters={allFilters} />
            </BsModal>
            <Grid item xs={12} sx={{ mt: -2.25 }}>
                <Datatable
                    columns={columns}
                    data={allOnBoardUser ?? []}
                    title="Assign Templates"
                    searchPlaceholder="Search by Name"
                    BtnComponent={<Button className="ml-2 w-auto" onClick={() => (handleAddModal(), setRowId(null))}>Assign Template Permission</Button>}
                    FilterComponent={AssignedFormFilters}
                    remote={true}
                    // FilterComponent={Filter}
                    filterConfig={filterConfig}
                    onServerSideChange={updateFilter}
                />
            </Grid>
            <DeleteModal
                open={open}
                setClose={setOpen}
                title={"Are you sure you want to Delete ?"}
                buttonText={"Delete"}
                handleSuccess={handleDelete}
            />
            {openDrawer ?
                <ListDrawer
                    open={openDrawer}
                    toggleDrawer={() => setOpenDrawer(!openDrawer)}
                    listData={[]}
                    title="Phase List" />
                : null
            }
        </Grid>
    );
};

export default FormAssigned;
